import { yupCustom, zCustom } from '@nucleus/lib-shape';
import { ISO8601Schema } from '@nucleus/src-platform/data';
import * as yup from 'yup';
import { z } from 'zod';
import { PublishableEntityBaseSchema, PublishableEntityBaseSchemaDeprecated } from './PublishableEntityBase';

export type PublishableEntity = z.infer<typeof PublishableEntitySchema>;

export const PublishableEntitySchema = PublishableEntityBaseSchema.extend({
  name: z.string().optional(),
  ownerId: z.string(),
  slug: zCustom.slugPath(),
  archivedAt: zCustom.iso().optional(),
  archivedBy: z.string().optional(),
});

/**
 * @deprecated this schema is deprecated and will be removed in the future
 */
export const PublishableEntitySchemaDeprecated: yup.SchemaOf<PublishableEntity> =
  PublishableEntityBaseSchemaDeprecated.shape({
    name: yup.string().optional(),
    ownerId: yup.string().required(),
    slug: yupCustom.slugPath.default(null).test('slug test', 'slug must be a string', (slug) => {
      if (typeof slug === 'string') {
        return true;
      } else {
        return false;
      }
    }),
    archivedAt: ISO8601Schema.optional(),
    archivedBy: yup.string().optional(),
  });
